import React from 'react'
import { FaPen } from "react-icons/fa";

export default function Button(props) {
  return (
    <a href='#' className={'button ' + props.cls}><span>Let’s Talk</span><i className='button-icon-pen'><FaPen/></i></a>
  )
}
